import { css } from '@emotion/react';
import { motion } from 'motion/react';
import { theme } from '@frontend/theme';
import { HoveredTimeProgressLine } from './progress-lines';
import { ADJUSTED_ONE_HOUR_IN_MINUTES, zIndex } from './utils';

interface Props {
  shouldShowHoverIndicator?: boolean;
  hourLabels: string[];
}

export const CalendarEventHourLines = ({ hourLabels, shouldShowHoverIndicator = false }: Props) => {
  const numberOfHours = hourLabels.length;
  return (
    <div css={styles.container(numberOfHours)}>
      {shouldShowHoverIndicator && <HoveredTimeProgressLine numberOfHours={numberOfHours} />}
      {hourLabels.map((hourLabels, idx) => (
        <motion.div layout='position' key={hourLabels + idx} css={styles.hourLine} />
      ))}
    </div>
  );
};

const styles = {
  container: (noOfHours: number) =>
    css({
      display: 'grid',
      gridRow: '1/-1',
      gridColumn: '1/-1',
      position: 'relative',
      backgroundColor: theme.colors.neutral5,
      gridTemplateRows: `repeat(${noOfHours}, minmax(${ADJUSTED_ONE_HOUR_IN_MINUTES}px, 1fr))`,
    }),
  hourLine: css({
    background: theme.colors.neutral20,
    height: 1,
    zIndex: zIndex.horizontalHourLines,
  }),
};
